import { render, staticRenderFns } from "./CustomRoleManager.vue?vue&type=template&id=048087f9"
import script from "./CustomRoleManager.vue?vue&type=script&lang=js"
export * from "./CustomRoleManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports